import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Fires a /api/track event on every route change. Uses a persistent
 * visitor id stored in localStorage so daily-unique counts work even
 * across reloads.
 */
export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    let visitor = localStorage.getItem("agg_visitor_id");
    api
      .post("/track", {
        path: location.pathname + (location.search || ""),
        referrer: document.referrer || "",
        session_id: visitor || "",
      })
      .then((r) => {
        if (!visitor && r.data?.visitor_id) {
          localStorage.setItem("agg_visitor_id", r.data.visitor_id);
        }
      })
      .catch(() => {});
  }, [location.pathname, location.search]);
}
